export enum LinkCategoryType {
    "privacy" = "privacy",
    "support" = "support"
}

export type LinkType = (typeof LinkCategoryType)[keyof typeof LinkCategoryType];

export type DropdownLinkObject = {
    type: LinkType;
    label?: string;
    url?: string;
}

export const dropdownLinksArray = [
    {
        type: LinkCategoryType.privacy,
        label: "Privacy and data",
        url: "https://resources.deloitte.com/sites/dr-uk/Shared%20Documents/Risk/DBS/DataPrivacy/Deloitte-employee-and-partner-fair-processing-notice.pdf"
    },
    {
        type: LinkCategoryType.privacy,
        label: "Rules of the Road",
        url: "https://ukdeloitte.sharepoint.com/sites/DOL-c-UK-UKDigitalAdoptionHub/UK/Forms/AllItems.aspx?id=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin%2FRules%20of%20the%20Road%2Epdf&parent=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin"
    },
    {
        type: LinkCategoryType.support,
        label: "Quick Reference Guide",
        url: "https://ukdeloitte.sharepoint.com/sites/DOL-c-UK-UKDigitalAdoptionHub/UK/Forms/AllItems.aspx?id=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin%2FRobin%20Quick%20Reference%20Guide%2Epdf&parent=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin"
    },
    {
        type: LinkCategoryType.support,
        label: "FAQ",
        url: "https://ukdeloitte.sharepoint.com/sites/DOL-c-UK-UKDigitalAdoptionHub/UK/Forms/AllItems.aspx?id=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin%2FFrequently%20Asked%20Questions%20%28FAQs%29%2Epdf&parent=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin"
    },
    {
        type: LinkCategoryType.support,
        label: "About Robin",
        url: "https://ukdeloitte.sharepoint.com/sites/DOL-c-UK-UKDigitalAdoptionHub/UK/Forms/AllItems.aspx?id=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin%2FAbout%20Page%2Epdf&parent=%2Fsites%2FDOL%2Dc%2DUK%2DUKDigitalAdoptionHub%2FUK%2FRobin"
    },
    {
        type: LinkCategoryType.support,
        label: "Report Incident",
        url: "https://deloitteemea.service-now.com/escgb?id=sc_cat_item&sys_id=6a45a7391b0afc90ffdceb18b04bcb3f"
    }
] satisfies DropdownLinkObject[];

export const dropdownLinksArrayPrivacy = dropdownLinksArray?.filter(obj => obj.type === LinkCategoryType.privacy) ?? [];
export const dropdownLinksArraySupport = dropdownLinksArray?.filter(obj => obj.type === LinkCategoryType.support) ?? [];

// Links for pilot version of Robin, to be removed once pilot is complete
export const dropdownLinksArrayPilot = [
    {
        type: LinkCategoryType.privacy,
        label: "Privacy and data",
        url: "https://resources.deloitte.com/sites/dr-uk/Shared%20Documents/Risk/DBS/DataPrivacy/Deloitte-employee-and-partner-fair-processing-notice.pdf"
    },
    {
        type: LinkCategoryType.privacy,
        label: "Rules of the Road",
        url: "https://ukdeloitte.sharepoint.com/sites/DigitalAssistantPilotResources/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FResources%2FRules%20of%20the%20Road%2FDA%20Pilot%20%2D%20Rules%20of%20the%20Road%2Epdf&parent=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FResources%2FRules%20of%20the%20Road"
    },
    {
        type: LinkCategoryType.support,
        label: "Quick Reference Guide",
        url: "https://ukdeloitte.sharepoint.com/sites/DigitalAssistantPilotResources/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FResources%2FQuick%20Ref%20Guide%2FDigital%20Assistant%20Quick%20Reference%20Guide%20v1%2E1%2Epdf&parent=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FResources%2FQuick%20Ref%20Guide"
    },
    {
        type: LinkCategoryType.support,
        label: "FAQ",
        url: "https://ukdeloitte.sharepoint.com/sites/DigitalAssistantPilotResources/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FResources%2FFAQs%2FDigital%20Assistant%20Pilot%20FAQs%5FFeb26%2Epdf&parent=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FResources%2FFAQs"
    },
    {
        type: LinkCategoryType.support,
        label: "About Robin",
        url: "https://ukdeloitte.sharepoint.com/sites/DigitalAssistantPilotResources/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FAbout%20Page%2FAbout%20page%2FAbout%20Digital%20Assistant%5FV02%2Epdf&parent=%2Fsites%2FDigitalAssistantPilotResources%2FShared%20Documents%2FAbout%20Page%2FAbout%20page"
    },
    {
        type: LinkCategoryType.support,
        label: "Report Incident",
        url: "https://deloitteemea.service-now.com/escgb?id=sc_cat_item&sys_id=6a45a7391b0afc90ffdceb18b04bcb3f"
    }
] satisfies DropdownLinkObject[];

export const dropdownLinksArrayPrivacyPilot = dropdownLinksArrayPilot?.filter(obj => obj.type === LinkCategoryType.privacy) ?? [];
export const dropdownLinksArraySupportPilot = dropdownLinksArrayPilot?.filter(obj => obj.type === LinkCategoryType.support) ?? [];
